import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import { bandwidthOnDemand, bandwidthOnDemandSubmitRequest } from 'utils/api/queries/omantelMicroApi';
import { AjaxResponse } from 'rxjs/ajax';
export interface requestPayload {
	subscriberNo: string;
	billingType: string;
	accountType: string;
	planCategory: string;
}
export class BandwidthOnDemand extends GenericService {
	// get service status and service information about microbundle additional benefits
	public static bandwidthOnDemand(data: requestPayload): Observable<AjaxResponse> {
		const payload = {
			...data,
		};
		return bandwidthOnDemand(payload)
			.withErrorHandling()
			.disableCache()
			.call();
	}
	public static bandwidthOnDemandSubmitRequest(data: any): Observable<AjaxResponse> {
		const payload = {
			...data,
		};
		return bandwidthOnDemandSubmitRequest(payload)
			.withErrorHandling()
			.disableCache()
			.call();
	}
}
